<template>
    <div>
        <!-- AddToAny BEGIN -->
        <div class="a2a_kit a2a_kit_size_32 a2a_default_style" :data-a2a-url="url" :data-a2a-title="title">
            <a class="a2a_dd" href="https://www.addtoany.com/share"></a>
            <a class="a2a_button_facebook"></a>
            <a class="a2a_button_twitter"></a>
            <a class="a2a_button_email"></a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SocialShare",
        props: ['url','title','message'],
        computed: {
            twitter_message: function () {
                return this.message + ' ${title} ${link}' + ' by @jdavidhobbs'
            },
        },
        mounted() {
            console.log(window.a2a_config.templates)
            window.a2a_config.callbacks.push({
                share: (data) => {
                    console.log(data);
                    window.a2a_config.templates.twitter = {
                        text: this.twitter_message,
                        related: "AddToAny,Twitter"
                    };
                    console.log(window.a2a_config.templates)
                    return {}
                }
            });
        }
    }
</script>

<style scoped>

</style>